/**
 * Cart-Token helper.
 *
 * The WooCommerce Store API uses a per-session `Cart-Token` (returned in the
 * response header of any cart / checkout call) instead of cookies. The browser
 * must echo it back on every subsequent Store API call.
 *
 * We persist it in sessionStorage so it survives React re-renders and route
 * changes, but is cleared when the tab is closed (matching Woo's cookie
 * session semantics).
 */

const TOKEN_KEY = 'raretto_cart_token_v1';

export function getCartToken() {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch {
    // sessionStorage may be unavailable (e.g. very old browsers, some
    // private-mode edge cases). Degrade to "no token" — the Store API will
    // issue a new one on the next call.
    return null;
  }
}

export function setCartToken(token) {
  if (!token) return;
  try {
    sessionStorage.setItem(TOKEN_KEY, token);
  } catch {
    // Storage quota / disabled storage — ignore. The next call will simply
    // not have a token and Woo will mint a fresh one.
  }
}

export function clearCartToken() {
  try {
    sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    /* noop */
  }
}
